import { AuthStorageDatasource } from '@react-apps/auth';
import { AuthApiDatasource } from '../data/datasources/auth-api.datasource';
import { AuthRepositoryImpl } from '../data/repositories/auth.repository.impl';
import type { StoredAuth } from '../domain/entities/auth.entity';

const api = new AuthApiDatasource();
const storage = new AuthStorageDatasource<StoredAuth>();
const repository = new AuthRepositoryImpl(api, storage);

export const authContainer = { repository };
